export default {
  headline: "Bewertungsbogen",
  name: "Name, Vorname",
  interval: "Berichtszeitraum von*",
  interval_invalid: "Bitte geben sie einen Berichtzeitraum an",
  interval_2: "bis*",
  interval_2_invalid: " ",
  comments: "Bemerkungen",
  signature: "Unterschrift {name}",
  evaluator: "Bewerter",
  signature_invalid: "Bitte unterschreiben Sie das Formular",
  date: "Datum",
  operation_part: "Betriebsteil",
  operation_part_invalid: "Betriebsteil",
}
